import type { AppToggleButtonProps } from "./AppToggleButton.Props";

export const isAppToggleButtonProps = (props: {
  type: string;
}): props is AppToggleButtonProps => {
  return (props as AppToggleButtonProps).type === "AppToggleButtonProps";
};
